import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad549fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-type-radio-group" }

import FormInvalidFeedback from "@/components/atoms/other/FormInvalidFeedback.vue";
import WorkTypeRadio from "@/components/atoms/orders/WorkTypeRadio.vue";
import { CustomFormOption } from "@/types/form/FormOption";
import { PropType } from "vue";

type RadioButtonOption = CustomFormOption<number>;


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkTypeRadioGroup',
  props: {
  value: {
    type: Number as PropType<number | null>,
    required: false
  },
  options: {
    type: Array as PropType<RadioButtonOption[]>,
    required: true,
    default: () => []
  },
  name: {
    type: String,
    required: true,
    default: ""
  },
  validationState: {
    type: Object,
    required: false
  }
},
  emits: ["update:value"],
  setup(__props, { emit }) {





const onChange = (v: string) => {
  emit("update:value", v);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: String(option.value),
          class: "work-type-radio-group-item"
        }, [
          _createVNode(WorkTypeRadio, {
            name: __props.name,
            value: option.value,
            "onUpdate:value": ($event: any) => ((option.value) = $event),
            id: `${__props.name}-option-${option.value}`,
            text: option.text,
            checked: __props.value === option.value,
            onChange: onChange
          }, null, 8, ["name", "value", "onUpdate:value", "id", "text", "checked"])
        ]))
      }), 128))
    ]),
    _createTextVNode(),
    _createVNode(FormInvalidFeedback, {
      "validation-state": __props.validationState,
      state: false
    }, null, 8, ["validation-state"])
  ]))
}
}

})